/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationCustomerGranteesMutation($input: SaveSimulationCustomerGrantees_M_simulation_customer_granteesInput!) {
    saveSimulationCustomerGrantees_M_simulation_customer_grantees(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
